import { render } from "./ProfitCard.vue?vue&type=template&id=180714ac&scoped=true"
import script from "./ProfitCard.vue?vue&type=script&lang=js"
export * from "./ProfitCard.vue?vue&type=script&lang=js"

import "./ProfitCard.vue?vue&type=style&index=0&id=180714ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180714ac"]])

export default __exports__